import script from "./Error.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error.vue?vue&type=script&setup=true&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=2e078278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e078278"]])

export default __exports__